<script>
import MenuToggle from '../MenuToggle'
import { messageSuccess } from '@utils/message'

// import { BRAND_MENU, SOLUTION_MENU, PRODUCT_MENU } from "@src/config/fake-data";
import { authComputed, globalComputed, optionComputed } from '@store/helpers'

export default {
  components: {
    MenuToggle,
  },
  props: {
    type: {
      type: String,
      default: 'default',
      validator(value) {
        return ['default', 'liff', 'brand'].includes(value)
      },
    }
  },
  data() {
    return {
      subMenuPage: {
        title: '',
        alias: '',
        description: '',
        list: [],
      },
      productSubMenuPage: {
        title: '',
        alias: '',
        list: [],
        category: '',
      },
      showMobileMenu: false,
      email: '',
      tryingSubscription: false,
      isMobileSearchOpen: false,
    }
  },
  computed: {
    ...authComputed,
    ...globalComputed,
    ...optionComputed,
    diaplayMenuLength() {
      return this.menuList
    },
    menuList() {
      let resultArr = [
        {
          text: 'About Zero One',
          to: "#about",
          type: 'nav',
        },
        {
          text: 'Products',
          to: "#brand",
          type: 'nav',
        },
        {
          text: 'Contact Us',
          to: "#contact",
          type: 'nav',
        }
      ]
      return resultArr
    },
    foramtLineId() {
      return (this.currentSetting.lineId || '').replace('@', '')
    }
  },
  methods: {
    onChangeMenuPage({ title, alias, description, list, name }) {
      this.subMenuPage = {
        title,
        alias,
        description,
        list,
        name,
      }
    },
    goTo(alias) {
      const router = () => {
        switch (this.subMenuPage.name) {
          case 'brand-list':
            return {
              name: 'brand-item',
              params: {
                brandAlias: alias,
              },
            }
          case 'product-list':
            return {
              name: 'product-list',
              query: {
                filterCategory: this.productSubMenuPage.category,
                filterBrand: alias,
              },
            }
          case 'solution-list':
            return {
              name: 'solution-list',
              query: {
                filterCategory: this.subMenuPage.alias,
                filterClass: alias,
              },
            }
        }
      }
      return {
        ...router(),
      }
    },
    async onSubscription() {
      this.tryingSubscription = true

      await this.$store
        .dispatch('global/subscribe', {
          email: this.email,
          newsletterCategoriesAlias: ['01_newsletter'],
        })
        .then(() => {
          this.tryingSubscription = false

          messageSuccess('已成功訂閱！')
        })
    },
    mobileSearchOpen(status) {
      this.isMobileSearchOpen = status
      this.showMobileMenu = false
    },
    showMobileMenuOpen(status) {
      this.showMobileMenu = status
      this.isMobileSearchOpen = false
    },
    onChangeSubMenuPage({ title, alias, list, name, category }) {
      this.productSubMenuPage = {
        title,
        alias,
        list,
        name,
        category,
      }
    },
    goToProductCategory(item) {
      this.$router.push({
        name: 'product-list',
        query: {
          filterCategory: item.alias,
        },
      })
    },
    goBack() {
      this.$router.back(-1)
    }
  },
}
</script>
<template>
  <header :class="[$style.header, { [$style.isHomePage]: $route.name === 'home' || $route.name === 'en' }, type === 'liff' ? $style.liff : '']">
    <template v-if="type === 'default' || type === 'brand'">
      <div class="header__inner d-none d-lg-block">
        <div class="container--menu">
          <div class="header__headerList">
            <!--Header Mask-->
            <div :data-length="diaplayMenuLength" class="header__mask"></div>
            <!--Header Left-->
            <div class="header__headerLeft">
              <router-link :to="{ name: 'home' }">
                <img alt="logo" class="header__logo" src="@assets/images/logo/logo.svg" />
              </router-link>
            </div>
            <!--Header Right-->
            <div class="header__headerRight">
              <div class="header__headerRightTop">
                <!--第二選單-->
                <ul :class="$style.secondNavList">
                  <li class="secondNavList__item">
                    <router-link class="secondNavList__link" to="#about"> About Zero One </router-link>
                  </li>
                  <li class="secondNavList__item">
                    <router-link class="secondNavList__link" to="#brand"> Products </router-link>
                  </li>
                  <li class="secondNavList__item">
                    <router-link class="secondNavList__link" to="#contact"> Contact Us </router-link>
                  </li>
                </ul>
                <!-- 中英頁面切換 -->
                <ul :class="$style.langList">
                  <li class="langList__item">
                    <router-link class="langList__link" :to="{ name: 'en' }"> EN </router-link>
                  </li>
                  <li class="langList__item">
                    <router-link class="langList__link" to="/zh-Tw"> 中文 </router-link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="header__inner d-block d-lg-none">
        <div class="header__headerList">
          <!--Header Left-->
          <div class="header__headerLeft" @click="showMobileMenuOpen(!showMobileMenu)">
            <i v-if="showMobileMenu" class="fal fa-fw fa-times header__hambuger"></i>
            <i v-else class="fal fa-fw fa-bars header__hambuger"></i>
          </div>
          <!--Header Center-->
          <div class="header__headerCenter">
            <router-link :to="{ name: 'en' }">
              <img v-if="$route.name !== 'home' && $route.name !== 'en'" alt="logo" class="header__logo" src="@assets/images/logo/logo.svg" />
              <img v-else alt="logo" class="header__logo" src="@assets/images/logo/logo_name.svg" />
            </router-link>
          </div>
          <!--Header Right-->
          <div class="header__headerRight"></div>
        </div>
        <transition name="el-fade-in-linear">
          <MobileSearch v-if="isMobileSearchOpen" @mobileSearchOpen="mobileSearchOpen" />
        </transition>
        <transition name="el-fade-in-linear">
          <div v-if="showMobileMenu" :class="[$style.mobileMenu, { mobileMenu__subMenuPage: subMenuPage.title }]">
            <transition-group name="el-fade-in-linear">
              <div v-show="subMenuPage.title && !productSubMenuPage.title" key="1" class="mobileMenu__subMenuPage">
                <baseButton class="isStylePrimary isTextUnderline mb-4 text-decoration-none" @click="onChangeMenuPage({ title: '', list: [] })">
                  <i class="fal fa-chevron-left"></i>
                  返回上一層
                </baseButton>
                <div class="text-base my-5 text-center">
                  {{ subMenuPage.title.split('-')[0] }} -
                  <span class="font-medium">
                    {{ subMenuPage.title.split('-')[1] }}
                  </span>
                </div>
                <div v-if="subMenuPage.description" class="text-base text-gray-6 mb-4 text-center">
                  {{ subMenuPage.description }}
                </div>
                <ul v-if="subMenuPage.alias === 'products'" :class="$style.subMenuPageList">
                  <li v-for="(subMenuPageItem, $index) in subMenuPage.list" :key="$index" class="subMenuPageList__item d-flex justify-content-between" @click="goToProductCategory(subMenuPageItem)">
                    {{ subMenuPageItem.title }}
                    <i
                      class="fal fa-chevron-right align-self-center pl-2"
                      @click.stop.prevent="
                        onChangeSubMenuPage({
                          title: `${subMenuPage.title.split('-')[1]} - ${subMenuPageItem.title}`,
                          alias: subMenuPage.alias,
                          list: subMenuPageItem.brands,
                          name: subMenuPage.name,
                          category: subMenuPageItem.alias,
                        })
                      "
                    >
                    </i>
                  </li>
                </ul>
                <ul v-else :class="$style.subMenuPageList">
                  <li v-for="(subMenuPageItem, $index) in subMenuPage.list" :key="$index" class="subMenuPageList__item">
                    <router-link class="subMenuPageList__link" :to="goTo(subMenuPageItem.alias)">
                      {{ subMenuPageItem.title }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <!-- second page -->
              <div v-show="productSubMenuPage.title" key="2" class="mobileMenu__subMenuPage">
                <baseButton class="isStylePrimary isTextUnderline mb-4 text-decoration-none" @click="onChangeSubMenuPage({ title: '', list: [] })">
                  <i class="fal fa-chevron-left"></i>
                  返回上一層
                </baseButton>
                <div class="text-base my-5 text-center">
                  {{ productSubMenuPage.title.split('-')[0] }} -
                  <span class="font-medium">
                    {{ productSubMenuPage.title.split('-')[1] }}
                  </span>
                </div>
                <ul :class="$style.subMenuPageList">
                  <li v-for="(subMenuPageItem, $index) in productSubMenuPage.list" :key="$index" class="subMenuPageList__item">
                    <router-link class="subMenuPageList__link" :to="goTo(subMenuPageItem.alias)">
                      {{ subMenuPageItem.title }}
                    </router-link>
                  </li>
                </ul>
              </div>
              <div v-show="!subMenuPage.title" key="3">
                <template v-for="(menuItem, index) in menuList">
                  <MenuToggle :key="index" :item="menuItem" @changeMenuPage="onChangeMenuPage" />
                </template>
                <div class="mt-5">
                  <el-divider class="isStyleHeader my-4"></el-divider>
                  <div class="socialMenu text-center">
                    <a v-if="currentSetting.fbFanpageUrl" :href="currentSetting.fbFanpageUrl" target="_blank" class="text-decoration-none socialMenu__item">
                      <i class="fab fa-facebook-square"></i>
                      <span class="sr-only">facebook</span>
                    </a>
                    <a v-if="foramtLineId" :href="`https://line.me/R/ti/p/%40${foramtLineId}`" target="_blank" class="text-decoration-none socialMenu__item">
                      <i class="fab fa-line"></i>
                      <span class="sr-only">line</span>
                    </a>
                    <a v-if="currentSetting.podcast" :href="currentSetting.podcast" target="_blank" class="text-decoration-none socialMenu__item">
                      <i class="far fa-podcast"></i>
                      <span class="sr-only">podcast</span>
                    </a>
                    <a v-if="currentSetting.youtubeUrl" :href="currentSetting.youtubeUrl" target="_blank" class="text-decoration-none socialMenu__item">
                      <i class="fab fa-youtube"></i>
                      <span class="sr-only">youtube</span>
                    </a>
                  </div>
                </div>
              </div>
            </transition-group>
          </div>
        </transition>
      </div>
    </template>
    <template v-if="type === 'liff'">
      <div class="header__inner">
        <span>
          <img alt="logo" class="header__logo" src="@assets/images/logo/logo.svg" />
        </span>
      </div>
    </template>
  </header>
</template>
<style lang="scss" module>
.mobileMenu {
  position: fixed;
  top: 70px;
  left: 0;
  width: 100%;
  height: calc(100vh - 70px);
  height: calc((var(--vh, 1vh) * 100) - 48px);
  padding: 2rem $container-gap;
  overflow: auto;
  background: #fff;
  @include max-md {
    top: 48px;
  }
  :global {
    .login {
      position: relative;
      margin: -2rem -19px;
      padding: 20px $container-gap;
    }
  }
  &:global {
    &.mobileMenu {
      &__subMenuPage {
        top: 0;
        z-index: 1035;
        height: 100vh;
        background: #fff;
      }
    }
  }
}

.header {
  position: relative;
  z-index: $z-index-header;
  height: 113px;
  letter-spacing: 0;

  @include max-lg {
    height: 70px;
  }

  @include max-md {
    height: 48px;
  }
  &.isHomePage {
    :global {
      .header__logo {
        @include max-md {
          width: 90px;
          top: -1px;
        }
      }
    }
  }
  :global {
    .header {
      &__logo {
        position: relative;
        top: -8px;
        width: 224px;

        @include max-lg {
          top: -3px;
          width: 166px;
        }

        @include max-lg {
          width: 120px;
        }
      }

      &__inner {
        position: fixed;
        top: 0;
        width: 100%;
        // min-height: 113px;
        background: rgba(255, 255, 255, 0.95);
        backdrop-filter: blur(3px);
        box-shadow: 0 10px 20px #25381019;

        &::before {
          position: absolute;
          right: 0;
          bottom: 0;
          left: 0;
          height: 6px;
          content: '';
          background: $color-primary;

          @include max-lg {
            height: 0;
          }
        }

        @include max-lg {
          height: 70px;
          padding-right: $container-gap;
          padding-left: $container-gap;
          background: #f4f6fa;
        }
        @include max-md {
          height: 48px;
        }
        > div.container--menu {
          padding-right: 60px;
          padding-left: 60px;
          height: 113px;
        }
      }

      &__mask {
        position: absolute;
        top: 0;
        bottom: 5px;
        left: 0;
        // width: calc(((100vw - #{$container-menu}) / 2) + 800px) ;
        // background: rgba(255,255,255,0.8);

        @for $i from 1 through 6 {
          $fix-width: (6 - $i) * 219;

          &[data-length='#{$i}'] {
            width: calc(((100vw - #{$container-menu}) / 2) + #{800 + $fix-width}px);

            @media screen and (max-width: $container-menu) {
              width: calc(100vw + #{$container-gap * 2} - #{1053 - $fix-width}px);
            }

            /* @include max-xl {
                $fix-width: (6 - $i) * 177;

                width: calc(100vw + #{$container-gap * 2} - #{447 + $fix-width}px);
              } */

            @include max-xl {
              $fix-width: (6 - $i) * 171;
              // background: red;
              width: calc(100vw + #{$container-gap * 2} - #{765 - $fix-width}px);
            }

            @include max-lg {
              $fix-width: (6 - $i) * 135;

              bottom: 4px;
              // background: red;
              width: calc(100vw + #{$container-gap * 2} - #{605 - $fix-width}px);
            }
          }
        }
      }

      &__headerList {
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;
        &::after {
          // position: absolute;
          // top: 0;
          // right: 0;
          // bottom: 5px;
          // width: calc((100vw - #{$container-menu}) / 2 + 30px);
          // content: '';
          // background: rgba(255,255,255,0.8);

          @media screen and (max-width: $container-menu) {
            width: 60px;
          }
        }
      }

      &__headerLeft {
        position: relative;
        padding: 1.3rem 0;

        @include max-lg {
          padding: 1.1rem 0;
        }
        @include max-md {
          padding: 0.5rem 0;
        }
      }

      &__headerRight {
        z-index: 1;
        padding-top: 1.125rem;
        min-width: 40px;

        @include max-lg {
          padding-top: 0.45rem;
        }

        @include max-md {
          padding-top: 0;
        }
      }

      &__headerRightTop,
      &__headerRightBottom {
        display: flex;
        align-items: center;
        justify-content: flex-end;
      }

      &__btn {
        padding-left: 0 !important;
      }

      &__icon {
        width: 14px;
        height: 14px;
        margin-top: -2px;
      }

      &__hambuger {
        font-size: 2rem;
        color: $color-primary;
      }
    }
  }
}

.liff {
  :global {
    .header__inner {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 130px;
      @include max-lg {
        height: 70px;
        background: #fff;
        &:before {
          height: 5px;
        }
      }

      @include max-md {
        height: 48px;
      }
    }
  }
}

.toolList {
  display: flex;
  align-items: center;
  min-width: 40px;

  :global {
    .toolList {
      &__item {
        padding: 0 0.5rem;

        &:last-child {
          padding-right: 0;
        }
      }

      &__tool {
        &.isLogin {
          // background-image: url(~@assets/images/icon/user.svg) !important;
          // background-repeat: no-repeat !important;
          // background-position: center !important;
          // background-size: 50% !important;
          // transition: all .3s;
          &:hover {
            // background: none !important;
            // background-image: url(~@assets/images/icon/user_primary.svg) !important;
            // background-repeat: no-repeat !important;
            // background-position: center !important;
            // background-size: 50% !important;
          }
        }
        &.isSearch {
          &:hover,
          &:active {
            background: transparent;
            text-decoration: none;
          }
          background: transparent !important;
          padding: 0;
        }

        &.isMember {
          padding-left: 3px;
          font-size: 0.875rem;
          border: 1px solid $color-primary;
          // color: $color-gray-7;
        }
      }
    }
  }
}
.secondNavList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  margin-right: 0.875rem;
  font-size: 1rem;

  @include max-lg {
    margin-top: 3rem;
    margin-right: 0;
  }

  @include max-md {
    flex-wrap: wrap;
  }

  :global {
    .secondNavList {
      &__item {
        position: relative;

        @include max-lg {
          flex-grow: 1;
          text-align: center;
        }

        @include max-md {
          width: 50%;
          padding: 5px 0;
        }

        &:not(:last-child) {
          &::before {
            position: absolute;
            top: 50%;
            right: 0;
            width: 1px;
            height: 1em;
            content: '';
            background: $color-primary;
            transform: translateY(-50%);
          }
        }

        @include max-md {
          &:not(:nth-child(odd)) {
            &::before {
              display: none;
            }
          }
        }
      }

      &__link {
        padding: 0 2.5rem;
        color: #1d293f;
        font-size: 1.125rem;
        @include max-lg {
          font-size: 0.875rem;
        }

        @include max-md {
          font-size: 1rem;
        }

        &:hover {
          color: $color-primary;
          text-decoration: none;
        }

        &.router-link-active {
          color: $color-primary;
        }
      }
    }
  }
}

.langList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  margin-right: -1.25rem;
  font-size: 1rem;

  @include max-lg {
    margin-top: 3rem;
    margin-right: 0;
  }

  @include max-md {
    flex-wrap: wrap;
  }

  :global {
    .langList {
      &__item {
        position: relative;

        @include max-lg {
          flex-grow: 1;
          text-align: center;
        }

        @include max-md {
          width: 50%;
          padding: 5px 0;
        }

        &:not(:last-child) {
          &::before {
            position: absolute;
            top: 50%;
            right: 0;
            width: 1px;
            height: 1em;
            content: '';
            background: $color-primary;
            transform: translateY(-50%);
          }
        }

        @include max-md {
          &:not(:nth-child(odd)) {
            &::before {
              display: none;
            }
          }
        }
      }

      &__link {
        padding: 0 1.25rem;
        color: #1d293f;

        @include max-lg {
          font-size: 0.875rem;
        }

        @include max-md {
          font-size: 1rem;
        }

        &:hover {
          color: $color-primary;
          text-decoration: none;
        }

        &.router-link-active {
          color: $color-primary;
        }
      }
    }
  }
}

.navList {
  @include list-unstyled;

  display: flex;
  align-items: center;
  margin-right: -2.5rem;

  @include max-xl {
    margin-right: -1.2rem;
  }
  // @media screen and (max-width: 1500px) {
  //   margin-right: -1.2rem;
  // }
  :global {
    .navList {
      &__item {
        z-index: 0;
        padding-left: 0;

        &:hover {
          .navList {
            &__megaMenu,
            &__subNav {
              pointer-events: auto;
              opacity: 1;
            }

            &__link {
              color: $color-primary;
              text-decoration: none;

              &::before {
                bottom: 0;
              }
            }
          }
        }

        &.hasSubNav {
          position: relative;
        }
      }

      &__link {
        position: relative;
        top: 2px;
        display: inline-block;
        height: 58px;
        padding: 0.8rem 2.5rem 1rem;
        overflow: hidden;
        color: #1d293f;

        @include max-xl {
          padding-right: 1rem;
          padding-left: 1rem;
        }

        @include max-lg {
          height: 45px;
          padding: 0.7rem 0.75rem 0.6rem;
          font-size: 0.875rem;
        }

        &::before {
          position: absolute;
          right: 0;
          bottom: -15px;
          left: 50%;
          z-index: -1;
          width: 0;
          height: 0;
          content: '';
          border-color: transparent transparent $color-primary transparent;
          border-style: solid;
          border-width: 0 7px 7px 7px;
          // background-image: url('~@assets/images/header/header-bg.png');
          // background-position: bottom center;
          transition: bottom 0.3s;
          transform: translateX(-50%);
        }

        &.router-link-active {
          color: $color-primary;
          &::before {
            bottom: 0 !important;
          }
        }
      }

      &__megaMenu {
        position: absolute;
        bottom: 0;
        left: 0;
        z-index: 1;
        width: 100vw;
        pointer-events: none;
        background: #f5f5f5;
        box-shadow: 0 10px 20px #21455827;
        opacity: 0;
        transition: opacity 0.3s;
        transform: translateY(100%);
      }

      &__subNav {
      }
    }
  }
}

.subMenuPageList {
  @include list-unstyled;
  padding-bottom: 1.5rem;
  :global {
    .subMenuPageList {
      &__item {
        padding: 1rem 2.56rem;
        border-bottom: 1px solid $color-gray-2;
      }

      &__link {
        color: $color-gray-7;

        &:hover {
          color: $color-primary;
          text-decoration: none;
        }
      }
    }
  }
}
</style>
